export interface ReceivedDocument {
  id?: number;
  taxPayerId?: number;
  documentType?: string;
  cdc?: string;
  documentNumber?: string;
  documentDate?: string;
  creationType?: string;
  supplierId?: number;
  supplierRuc?: string;
  supplierSocialName?: string;
  supplierFantasyName?: string;
  clientRuc?: string;
  clientSocialName?: string;
  saleType?: string;
  currency?: string;
  pygExchangeRate?: number;
  amount?: number;
  amount10Percent?: number;
  amount5Percent?: number;
  amountExempt?: number;
  iva10Percent?: number;
  iva5Percent?: number;
  taxed10Percent?: number;
  taxed5Percent?: number;
  obs?: string;
  createdAt?: string;
  updatedAt?: string;
}

export const DOCUMENT_TYPE_INVOICE = "invoice";
export const DOCUMENT_TYPE_INVOICE_LABEL = "Factura Electrónica";
export const DOCUMENT_TYPE_CREDIT_NOTE = "credit_note";
export const DOCUMENT_TYPE_CREDIT_NOTE_LABEL = "Nota de Crédito Electrónica";
export const DOCUMENT_TYPE_DEBIT_NOTE = "debit_note";
export const DOCUMENT_TYPE_DEBIT_NOTE_LABEL = "Nota de Débito Electrónica";

export const DOCUMENT_TYPE_CHOICES: { value: string; label: string }[] = [
  { value: DOCUMENT_TYPE_INVOICE, label: DOCUMENT_TYPE_INVOICE_LABEL },
  { value: DOCUMENT_TYPE_CREDIT_NOTE, label: DOCUMENT_TYPE_CREDIT_NOTE_LABEL },
  { value: DOCUMENT_TYPE_DEBIT_NOTE, label: DOCUMENT_TYPE_DEBIT_NOTE_LABEL },
];

export const DOCUMENT_TYPE_LABELS: Record<string, string> = {
  [DOCUMENT_TYPE_INVOICE]: DOCUMENT_TYPE_INVOICE_LABEL,
  [DOCUMENT_TYPE_CREDIT_NOTE]: DOCUMENT_TYPE_CREDIT_NOTE_LABEL,
  [DOCUMENT_TYPE_DEBIT_NOTE]: DOCUMENT_TYPE_DEBIT_NOTE_LABEL,
};

export const CREATION_TYPE_MANUAL = "manual";
export const CREATION_TYPE_CDC = "cdc";

export const SALE_TYPE_CASH = "cash";
export const SALE_TYPE_CASH_LABEL = "Contado";
export const SALE_TYPE_CREDIT = "credit";
export const SALE_TYPE_CREDIT_LABEL = "Crédito";

export const newReceivedDocument = (taxPayerId?: number): ReceivedDocument => {
  return {
    taxPayerId: taxPayerId,
    documentType: DOCUMENT_TYPE_INVOICE,
    creationType: CREATION_TYPE_MANUAL,
    currency: "PYG",
  };
};

export const formatDocumentNumber = (doc: ReceivedDocument): string => {
  return doc.documentNumber ?? "";
};
